export default {
      id: "ic-soc-youtube-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-soc-youtube-usage",
      toString: function () {
        return this.url;
      }
    }